module.exports = "<style>\r\n</style>\r\n\r\n\r\n<span *ngIf=\"value !== ''\">\r\n\t<ng-container *ngIf=\"kind == ''\">{{value}}</ng-container>\r\n\t<ng-container *ngIf=\"kind == 'decimal'\">{{value | number : '1.2-2'}}</ng-container>\r\n\t<ng-container *ngIf=\"kind == 'decimal-0'\">{{value | number : '1.0-0'}}</ng-container>\r\n\t<ng-container *ngIf=\"kind == 'percentage'\">{{value | percent : '1.2-2'}}</ng-container>\r\n\t<ng-container *ngIf=\"kind == 'percentage-4'\">{{value | percent : '1.4-4'}}</ng-container>\r\n</span>\r\n";


//////////////////
// WEBPACK FOOTER
// ./TypeScript/shared/components/nbr-display.component.html
// module id = 389
// module chunks = 10